module.exports = __webpack_public_path__ + "14_ldav_teaser.bmp?772f15ca82c22b58f83a6b6258f66a53";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperData/14_ldav_teaser.bmp
// module id = 138
// module chunks = 0